import { arrayMove } from '@dnd-kit/sortable'
import { useCallback, useState } from 'react'
import { ConditionType, type MappingRule } from '../types'

export default function useMappingRules() {
  const [mappingRules, setMappingRules] = useState<MappingRule[]>([])
  const [movedCardId, setMovedCardId] = useState<string | null>(null)

  const [lastAddedId, setLastAddedId] = useState<string | null>(null)

  const addRule = useCallback(() => {
    const id = `rule-${Date.now()}`
    const newRule: MappingRule = {
      id,
      target: '',
      condition: ConditionType.DIRECT_MAPPING,
      source: '',
      normalize: [],
    }
    setMappingRules((prev) => [...prev, newRule])
    setLastAddedId(id)
  }, [])

  const updateRule = useCallback((updated: MappingRule) => {
    setMappingRules((prev) =>
      prev.map((r) => (r.id === updated.id ? updated : r))
    )
  }, [])

  const removeRule = useCallback((id: string) => {
    setMappingRules((prev) => prev.filter((r) => r.id !== id))
  }, [])

  const triggerMoveAnimation = useCallback((id: string) => {
    setMovedCardId(id)
    setTimeout(() => setMovedCardId(null), 400)
  }, [])

  const reorderRules = useCallback(
    (activeId: string, overId: string) => {
      setMappingRules((prev) => {
        if (activeId === overId) return prev
        const oldIndex = prev.findIndex((r) => r.id === activeId)
        const newIndex = prev.findIndex((r) => r.id === overId)
        if (oldIndex < 0 || newIndex < 0) return prev
        if (oldIndex === newIndex) return prev
        return arrayMove(prev, oldIndex, newIndex)
      })
      triggerMoveAnimation(activeId)
    },
    [triggerMoveAnimation]
  )

  const resetRules = useCallback(() => {
    setMappingRules([])
  }, [])

  return {
    mappingRules,
    setMappingRules,
    movedCardId,
    lastAddedId,
    addRule,
    updateRule,
    removeRule,
    reorderRules,
    resetRules,
  }
}
